import { gridSizeMdLg12, gridSizeMdLg4, newNapsCambioPuertosSchema, ROUTER_PATHS } from "@/shared";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  getContrato,
  // useCreateNaps,
  useFetchCitiesEnabled,
  useFetchNodos,
  useFetchOLTs,
  useFetchSectors,
  useUpdateNaps,
} from "@/shared/actions/erp";
import {
  CustomAutocomplete,
  CustomAutocompleteArrStringNoForm,
  CustomTextField,
  SampleCheckbox,
  SampleTable,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import PortsSelect from "@/shared/components/ui/PuertosSelect";
import { City, Contrato, CurrentPuertoNap, EstadoPuertoNap, EstadoPuertoNapOptions, Naps, Nodo, OLT, PuertoNap, Sector } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Grid, IconButton, Typography } from "@mui/material";
import ShowClienteByIdContratoModal from "@/shared/components/erp/clientes/ShowClienteByIdContratoModal";
import { MRT_ColumnDef } from "material-react-table";
import { Visibility } from "@mui/icons-material";
// const returnUrlRadioBase = "/mantenimiento-operaciones/naps";

export interface SavePuertosDisponiblesPageProps {
  titlePage: string;
  editNaps?: Naps;
}
type SaveFormData = {
  codigo?: string;
  nombre: string;
  direccion?: string;
  coordenadas: string;
  latitud: number;
  longitud: number;
  estado_nap: boolean;
  proyecto_cod: string;
  es_soterrado: boolean;
  nodo: string;
  olt: string;
  sector?: string;
  ciudad?: string;
  estado: boolean;
  puertos?: CurrentPuertoNap[] | PuertoNap[];
  puertosTabla?: CurrentPuertoNap[];
  currentRowSelected?:CurrentPuertoNap
};
const SavePuertosDisponiblesPage: React.FC<SavePuertosDisponiblesPageProps> = ({titlePage, editNaps }) => {
  const navigate = useNavigate();

  const returnUrl = ROUTER_PATHS.activaciones.activacionCajasPuertosDisponiblesNav;
  //*local state
  const [openDataClientModal, setOpenDataClientModal] = useState(false);
  const [dataContrato, setDataContrato] = useState<Pick<Contrato, "id_contrato"| "cliente_data">|null>(null);
  const [shrink, setShrink] = useState(false);
  const [portCount, setPortCount] = useState(
    editNaps?.puertos?.length.toString() ?? "16"
  ); // Inicializa el estado con el valor por defecto

  // ...resto del código

  ///* global state
  const setAlert = useUiStore((s) => s.setAlert);

  ///* fetch data
  const { data: SectorsPaging, isLoading: isLoadingSectors } = useFetchSectors({
    page_size: 600,
  });
  const { data: CitiesPaging, isLoading: isLoadingCities } =
    useFetchCitiesEnabled({
      params: {
        page_size: 600,
      },
      enabled: true,
    });
  const { data: OLTPaging, isLoading: isLoadingOLT } = useFetchOLTs({
    params: {
      page_size: 600,
    },
  });
  const { data: NodoPaging, isLoading: isLoadingNodo } = useFetchNodos({
    page_size: 600,
  });
  ///* form
  useEffect(() => {
    const newPorts: PuertoNap[] = [];
    for (let i = 0; i < Number(portCount); i++) {
      newPorts.push({ estado: EstadoPuertoNap.DISPONIBLE, puerto: `${i + 1}`, id_cliente_contrato:null });
    }
    form.setValue("puertos", newPorts);
  }, [portCount]);
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newNapsCambioPuertosSchema),
    defaultValues: {
      estado: false,
    },
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;
  ///* mutations
  // const createNaps = useCreateNaps({ navigate, returnUrl: returnUrlRadioBase });
  const updateNaps = useUpdateNaps({ navigate, returnUrl: returnUrl });
  ///* handlers
  const onSave = () => {
    if (!isValid) return;
    if (editNaps?.id_nap) {
      form.reset({
        ...form.getValues(),
        puertos: form.getValues()?.puertosTabla,
      })
      return updateNaps.mutate({
        id: editNaps.id_nap,
        data: form.getValues() as any,
      });
    }
    ///* create
    // return createNaps.mutate(form.getValues() as any);
  };
  ///*fetch
  const onChangeCities = (value: string) => {
    form.setValue("ciudad", value);
  };
  const onChangeSectors = (value: string) => {
    form.setValue("sector", value);
  };

  useEffect(() => {
    if (editNaps) {
      setShrink(true);
       editNaps?.puertos;
      reset({
        ...editNaps as any,
        puertosTabla: editNaps?.puertos
      });
    }
  }, [editNaps]);

  // const {
  //   columnsPuertosTable
  // } = useTablePuertos({setOpenModalDataCliente:setOpenDataClientModal})


  const CheckDataWithModal = ({rowData}:{rowData:CurrentPuertoNap}) => {
    return <>
        {/* <Tooltip title={"Ver Cliente"}> */}
            <IconButton onClick={async()=>{
              form.reset({
                ...form.getValues(),
                currentRowSelected: rowData
              })
              if(rowData?.id_cliente_contrato && rowData?.id_cliente_contrato!=""){
                const dataContrato = await getContrato(rowData.id_cliente_contrato)
                setDataContrato(dataContrato?.data||null)
              }else{
                setDataContrato(null)
              }
              setOpenDataClientModal(true)
            }
            }>
                <Visibility color={rowData?.id_cliente_contrato?"info":"disabled"}/>
            </IconButton>
        {/* </Tooltip> */}
    </>
  }

  const columnsPuertosTable = useMemo<MRT_ColumnDef<CurrentPuertoNap>[]>(
        () => [
      {
          accessorKey: 'puerto',
          header: 'puerto',
          size: 300,
      },
      {
          accessorKey: 'estado',
          header: 'estado',
          size: 300,
          Cell: ({row})=><CustomAutocompleteArrStringNoForm
            label="Estado"
            options={EstadoPuertoNapOptions}
            defaultValue={row.original?.estado || ''}
            size={gridSizeMdLg12}
            onChangeValue={(val)=>{
              const dataRow = row.original
              const newArrayPuertos = form?.getValues()?.puertosTabla?.map((x)=>{
                if(x.puerto==dataRow.puerto){
                  x.estado = val;
                  x.id_cliente_contrato=null
                  return x
                }
                return x
              })
              form.reset({
                ...form?.getValues(),
                puertosTabla : newArrayPuertos
              })
            }}
          />
      },
      {
          accessorKey: 'id_cliente_contrato',
          header: 'Cliente',
          size: 300,
          Cell: ({row}) => {
            
            // if(row.original?.id_cliente_contrato){
              return <CheckDataWithModal rowData={row.original || null} />
            // }else{
            //   return null;
            // }
          },
      },
      ],
      []
  );

  return (
    <SingleTableBoxScene
      title={titlePage||"Naps"}
      enableBackBtn={true}
      backPageUrl={returnUrl}//"/mantenimiento-operaciones/naps"
      visibleReport={false}
      enableCreateOrEditBtn={true}
      textCreateOrEditBtn="Guardar"
      fnCreateOrEdit={handleSubmit(onSave, () => {
        setAlert(true, "Faltan campos por llenar", "error");
      })}
    >
      <Grid container spacing={3}>
        <CustomTextField
          name="nombre"
          label="Nombre"
          control={form.control}
          defaultValue={form.getValues().nombre || ""}
          error={errors.nombre}
          helperText={errors.nombre?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
        <CustomTextField
          name="direccion"
          label="Direccion"
          control={form.control}
          defaultValue={form.getValues().direccion || ""}
          error={errors.direccion}
          helperText={errors.direccion?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
        <CustomTextField
          name="coordenadas"
          label="Coordenadas"
          type="coordenadas"
          control={form.control}
          defaultValue={form.getValues().coordenadas || ""}
          error={errors.coordenadas}
          helperText={errors.coordenadas?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
          disabled
        />

        <CustomTextField
          name="latitud"
          type="latitud"
          label="Latitud"
          control={form.control}
          defaultValue={form.getValues().latitud || ""}
          error={errors.latitud}
          helperText={errors.latitud?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
          onChangeValue={(value, valid) => {
            if (valid) {
              form.setValue(
                "coordenadas",
                `${value},${form.getValues().longitud}`
              );
            }
          }}
        />

        <CustomTextField
          name="longitud"
          type="longitud"
          label="Longitud"
          control={form.control}
          defaultValue={form.getValues().longitud || ""}
          error={errors.longitud}
          helperText={errors.longitud?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
          onChangeValue={(value, valid) => {
            if (valid) {
              form.setValue(
                "coordenadas",
                `${+form.getValues().latitud},${value} `
              );
            }
          }}
        />

        <CustomTextField
          name="proyecto_cod"
          label="Proyecto cod"
          control={form.control}
          defaultValue={form.getValues().proyecto_cod || ""}
          error={errors.proyecto_cod}
          helperText={errors.proyecto_cod?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />

        <CustomAutocomplete<OLT>
          label="OLT"
          name="olt"
          actualValueKey="codigo"
          //// options
          options={OLTPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          //
          defaultValue={form.getValues().olt || ""}
          optionLabelForEdit={form.getValues().olt || ""}
          isLoadingData={isLoadingOLT}
          //// validation
          control={control}
          error={errors.olt}
          helperText={errors.olt?.message}
          onChangeValue={(e) => form.setValue("olt", e)}
          size={gridSizeMdLg4}
        />
        <CustomAutocomplete<Nodo>
          label="Nodo"
          name="nodo"
          actualValueKey="codigo"
          //// options
          options={NodoPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          //
          defaultValue={form.getValues().nodo || ""}
          optionLabelForEdit={form.getValues().nodo || ""}
          isLoadingData={isLoadingNodo}
          //// validation
          control={control}
          error={errors.nodo}
          helperText={errors.nodo?.message}
          onChangeValue={(e) => form.setValue("nodo", e)}
          size={gridSizeMdLg4}
        />
        <CustomAutocomplete<City>
          label="Ciudad"
          name="ciudad"
          //// options
          options={CitiesPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          actualValueKey="codigo"
          //
          defaultValue={form.getValues().ciudad || ""}
          isLoadingData={isLoadingCities}
          //// validation
          control={control}
          error={errors.ciudad}
          helperText={errors.ciudad?.message}
          onChangeValue={onChangeCities}
          size={gridSizeMdLg4}
          optionLabelForEdit={
            CitiesPaging?.data.data.find(
              (z: any) => z.codigo === form.getValues().ciudad
            )?.nombre ?? ""
          }
        />
        <CustomAutocomplete<Sector>
          label="Sector"
          name="sector"
          //// options
          options={SectorsPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          actualValueKey="codigo"
          //
          defaultValue={form.getValues().sector || ""}
          optionLabelForEdit={
            SectorsPaging?.data.data.find(
              (z: any) => z.codigo === form.getValues().sector
            )?.nombre ?? ""
          }
          isLoadingData={isLoadingSectors}
          //// validation
          control={control}
          error={errors.sector}
          helperText={errors.sector?.message}
          onChangeValue={onChangeSectors}
          size={gridSizeMdLg4}
        />

        <PortsSelect
          label="Puertos"
          register={{ onChange: (event) => setPortCount(event.target.value) }}
          defaultValue={portCount}
          size={gridSizeMdLg4}
        />

        <SampleCheckbox
          label="Soterrado"
          name="es_soterrado"
          control={form.control}
          defaultValue={!!form.getValues().es_soterrado}
          size={gridSizeMdLg4}
        />

        <SampleCheckbox
          label="Estado NAP"
          name="estado_nap"
          control={form.control}
          defaultValue={!!form.getValues().estado_nap}
          size={gridSizeMdLg4}
        />

        <SampleCheckbox
          label="Estado"
          name="estado"
          control={form.control}
          defaultValue={!!form.getValues().estado}
          size={gridSizeMdLg4}
        />
      </Grid>
      <Grid {...gridSizeMdLg12}  container item paddingY={4}>
        <Typography variant="h6">
          Puertos Disponibles
        </Typography>
      </Grid>
      <Grid {...gridSizeMdLg12} container item justifyContent={"center"}>
        <SampleTable<CurrentPuertoNap>
          columns={columnsPuertosTable}
          data={form?.getValues()?.puertosTabla as CurrentPuertoNap[] || []}
          isLoading={false}
          enableGlobalFilter={false}
          rowCount={editNaps?.puertos?.length}
          enableSticky={true}
          maxHeight={500}
        />
      </Grid>


      {/* Modal info cliente a partir del contrato */}
      <ShowClienteByIdContratoModal form={form} dataContrato={dataContrato||null} 
      open={openDataClientModal} setOpen={setOpenDataClientModal}/>

    </SingleTableBoxScene>
  );
};

export default SavePuertosDisponiblesPage;
